


















import { Component, Vue } from "vue-property-decorator";
import EquipmentMaintenanceTab from "./EquipmentMaintenanceTab.vue";
import JobMaintenanceTab from "./JobMaintenanceTab.vue";
@Component({
  components: {
    JobMaintenanceTab,
    EquipmentMaintenanceTab,
  },
})
export default class EquipmentMaintenance extends Vue {
  tab = 0;
  onChangeTabs(tabSelected) {
    if(tabSelected === 1) {
      this.$store.commit("JOB_TAB_CLICK");
    }
    if(tabSelected === 0) {
      this.$store.commit("EQUIPMENT_TAB_CLICK");
    }
  }
  mounted() {
    this.$store.commit("EQUIPMENT_TAB_CLICK");
  }
}
